module.exports = __webpack_public_path__ + "img/goal-material.1a255d17.png";